export default __webpack_public_path__ + "static/media/extrude.17c41e34.svg";